import styled from 'styled-components'

export const ListRowStyled = styled.button<{ $selected: boolean }>`
  display: block;
  width: 100%;
  text-align: left;
  border: none;
  cursor: pointer;
  padding: ${({ theme }) => `${theme.space.small} ${theme.space.xsmall}`};
  border-bottom: 1px solid ${({ theme }) => theme.colors.content.border};
  background: ${({ theme, $selected }) =>
    $selected ? theme.colors.selected : 'transparent'};
  color: ${({ theme, $selected }) =>
    $selected ? theme.colors.primary : theme.colors.text.secondary};

  &:hover {
    background: ${({ theme }) => theme.colors.selected};
  }
`
